// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum StepperActionTypes {
  GET_STEP_VEHICLE_DETAILS = 'GET_STEP_VEHICLE_DETAILS',
  GET_STEP_DRIVER_DETAILS = 'GET_STEP_DRIVER_DETAILS',
  GET_STEP_COMPARE_QOUTES = 'GET_STEP_COMPARE_QOUTES',
  GET_STEP_YOUR_COVER = 'GET_STEP_VEHICLE_DETAILS'
  }
  